import { IGatsbyImageData } from "gatsby-plugin-image";
import { getGatsbyImageData, GatsbyImageDataArgs } from "gatsby-source-sanity";
import { ImageNode } from "gatsby-source-sanity/lib-es5/images/getGatsbyImageProps";

export interface GetSanityImageParams {
  imageAssetId?: ImageNode;
  imageAssetConfig?: GatsbyImageDataArgs;
}

export const getSanityImage = ({
  imageAssetId,
  imageAssetConfig
}: GetSanityImageParams): IGatsbyImageData | null => {
  const sanityConfig = {
    projectId: "gjkptnx9",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  };

  const imageData = getGatsbyImageData(
    imageAssetId,
    {
      ...imageAssetConfig
    },
    sanityConfig
  );

  return imageData;
};
